import { Component, computed, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { JobStatusUtils, JobStatusV4 } from '@core/models/optimization.model';

export function jobStatusDotClass(status: JobStatusV4): string {
  return JobStatusUtils.isStatusFinished(status)
    ? 'bg-green-500'
    : JobStatusUtils.isStatusRunning(status)
      ? 'animate-pulse bg-blue-500'
      : JobStatusUtils.isStatusSent(status)
        ? 'bg-yellow-500'
        : JobStatusUtils.isBlockedStatus(status)
          ? 'bg-warning'
          : JobStatusUtils.isErrorStatus(status)
            ? 'bg-red-500'
            : 'bg-gray-500';
}

export function jobStatusTextClass(status: JobStatusV4): string {
  return JobStatusUtils.isStatusFinished(status)
    ? 'text-green-600 dark:text-green-400'
    : JobStatusUtils.isUnfinishedStatus(status)
      ? 'text-blue-600 dark:text-blue-400'
      : JobStatusUtils.isBlockedStatus(status)
        ? 'text-warning'
        : JobStatusUtils.isErrorStatus(status)
          ? 'text-red-600 dark:text-red-400'
          : 'text-text-secondary';
}

@Component({
  selector: 'app-optimization-job-status',
  imports: [TranslatePipe],
  template: `
    @if (pending()) {
      <span
        class="inline-flex items-center gap-1.5 font-semibold text-blue-600 dark:text-blue-400">
        @if (running()) {
          <svg
            width="11"
            height="11"
            viewBox="0 0 16 16"
            style="animation: spin 0.9s linear infinite">
            <circle
              cx="8"
              cy="8"
              r="6"
              fill="none"
              stroke="currentColor"
              stroke-opacity="0.2"
              stroke-width="2" />
            <path
              d="M 8 2 a 6 6 0 0 1 6 6"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round" />
          </svg>
        } @else {
          <span class="h-1.5 w-1.5 animate-pulse rounded-full bg-blue-500"></span>
        }
        {{ 'features.plan.jobs.status.' + status() | translate }}
      </span>
    } @else {
      <span class="inline-flex items-center gap-1.5 font-semibold" [class]="textClass()">
        <span class="h-1.5 w-1.5 rounded-full" [class]="dotClass()"></span>
        {{ 'features.plan.jobs.status.' + status() | translate }}
      </span>
    }
  `,
  styles: ``
})
export class OptimizationJobStatusComponent {
  readonly status = input.required<JobStatusV4>();
  protected readonly pending = computed(() =>
    JobStatusUtils.isUnfinishedStatus(this.status())
  );
  protected readonly running = computed(() =>
    JobStatusUtils.isStatusRunning(this.status())
  );
  protected readonly textClass = computed(() => jobStatusTextClass(this.status()));
  protected readonly dotClass = computed(() => jobStatusDotClass(this.status()));
}
